import * as e from "react";
import { u as I, c as O, a as S } from "./index.stoqs9MZ.js";
import { u as D } from "./index.B4ZV02se.js";
import { P as v } from "./index.DMLWxr4u.js";
import { P as L } from "./index.TrmYLGk6.js";
import { u as M } from "./index.BUG7NYeV.js";
import { j as c } from "./jsx-runtime.DGlMoOmv.js";
var k = globalThis?.document ? e.useLayoutEffect : () => {
}, f = "Collapsible", [F, Q] = O(f), [B, g] = F(f), T = e.forwardRef(
  (t, s) => {
    const {
      __scopeCollapsible: r,
      open: a,
      defaultOpen: o,
      disabled: l,
      onOpenChange: i,
      ...m
    } = t, [p, d] = I({
      prop: a,
      defaultProp: o ?? !1,
      onChange: i,
      caller: f
    });
    return /* @__PURE__ */ c.jsx(
      B,
      {
        scope: r,
        disabled: l,
        contentId: M(),
        open: p,
        onOpenToggle: e.useCallback(() => d((C) => !C), [d]),
        children: /* @__PURE__ */ c.jsx(
          v.div,
          {
            "data-state": h(p),
            "data-disabled": l ? "" : void 0,
            ...m,
            ref: s
          }
        )
      }
    );
  }
);
T.displayName = f;
var j = "CollapsibleTrigger", w = e.forwardRef(
  (t, s) => {
    const { __scopeCollapsible: r, ...a } = t, o = g(j, r);
    return /* @__PURE__ */ c.jsx(
      v.button,
      {
        type: "button",
        "aria-controls": o.contentId,
        "aria-expanded": o.open || !1,
        "data-state": h(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        disabled: o.disabled,
        ...a,
        ref: s,
        onClick: S(t.onClick, o.onOpenToggle)
      }
    );
  }
);
w.displayName = j;
var R = "CollapsibleContent", A = e.forwardRef(
  (t, s) => {
    const { forceMount: r, ...a } = t, o = g(R, t.__scopeCollapsible);
    return /* @__PURE__ */ c.jsx(L, { present: r || o.open, children: ({ present: l }) => /* @__PURE__ */ c.jsx(G, { ...a, ref: s, present: l }) });
  }
);
A.displayName = R;
var G = e.forwardRef((t, s) => {
  const { __scopeCollapsible: r, present: a, children: o, ...l } = t, i = g(R, r), [m, p] = e.useState(a), d = e.useRef(null), C = D(s, d), x = e.useRef(0), y = x.current, P = e.useRef(0), N = P.current, b = i.open || m, E = e.useRef(b), u = e.useRef(void 0);
  return e.useEffect(() => {
    const n = requestAnimationFrame(() => E.current = !1);
    return () => cancelAnimationFrame(n);
  }, []), k(() => {
    const n = d.current;
    if (n) {
      u.current = u.current || {
        transitionDuration: n.style.transitionDuration,
        animationName: n.style.animationName
      }, n.style.transitionDuration = "0s", n.style.animationName = "none";
      const _ = n.getBoundingClientRect();
      x.current = _.height, P.current = _.width, E.current || (n.style.transitionDuration = u.current.transitionDuration, n.style.animationName = u.current.animationName), p(a);
    }
  }, [i.open, a]), /* @__PURE__ */ c.jsx(
    v.div,
    {
      "data-state": h(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !b,
      ...l,
      ref: C,
      style: {
        "--radix-collapsible-content-height": y ? `${y}px` : void 0,
        "--radix-collapsible-content-width": N ? `${N}px` : void 0,
        ...t.style
      },
      children: b && o
    }
  );
});
function h(t) {
  return t ? "open" : "closed";
}
var U = T, V = w, W = A;
export {
  A as C,
  U as R,
  V as T,
  W as a,
  Q as c
};
//# sourceMappingURL=index.DmdlVKe8.js.map
